import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { AppConfigService } from './app/core/config/config.service';

// Thay đổi key trong formData KHi tải ảnh lên trong ckEditor
// Chặn tất cả các yêu cầu XMLHttpRequest.
// Chặn XMLHttpRequest.
const originalXhrSend = XMLHttpRequest.prototype.send;
const originalXhrOpen = XMLHttpRequest.prototype.open;
let urlSave = '';
XMLHttpRequest.prototype.open = function (
  method: string,
  url: string,
  async?: boolean,
  user?: string,
  password?: string
) {
  urlSave = url; // Lưu lại URL nếu cần.
  return originalXhrOpen.apply(this, arguments as any);
};

XMLHttpRequest.prototype.send = function (
  body?: Document | XMLHttpRequestBodyInit | null
) {
  const xhr = this;
  if (urlSave === 'https://cdn-test.eztek.net/gateway/Media/Upload') {
    // Ghi đè onreadystatechange để chỉnh sửa response JSON.

    if (body instanceof FormData) {
      // Tạo một FormData mới để thay thế key.
      const newFormData = new FormData();
      const oldKey = 'upload'; // Thay thế bằng key bạn muốn đổi.
      const newKey = 'file'; // Thay thế bằng key mới.

      // Duyệt qua các trường trong FormData ban đầu.
      body.forEach((value, key) => {
        if (key === oldKey) {
          // Thêm key mới thay thế key cũ.
          newFormData.append(newKey, value);
        } else {
          // Giữ nguyên các key khác.
          newFormData.append(key, value);
        }
      });
      // Sử dụng FormData mới khi gửi request.
      return originalXhrSend.apply(this, [newFormData]);
    }
  }

  // Nếu không phải FormData, gửi request với body gốc.
  return originalXhrSend.apply(this, [body]);
};

AppConfigService.loadConfig().then(() => {
  return platformBrowserDynamic().bootstrapModule(AppModule);
});


